<!--
 * @Description: 教职工详情 “双师型”教师聘用
 * @Author: 张天伟
 * @Date: 2023-03-08 17:10:41
 * @LastEditors: PF
 * @LastEditTime: 2024-10-15 16:52:49
-->

<template>
  <div>
    <el-descriptions class="descript-box" v-for="(item, index) in tableData" :key="index" :column="4" border>
      <el-descriptions-item label="双师类型" label-align="right" align="left" width="170px" span="2">{{item.sslx}}</el-descriptions-item>
      <el-descriptions-item label="获得双师日期" label-align="right" align="left" width="170px" span="2">{{item.hdssrq}}</el-descriptions-item>
      <el-descriptions-item label="证书颁发机构" label-align="right" align="left" width="170px" span="2">{{item.zsbfjg}}</el-descriptions-item>
      <el-descriptions-item label="职业资格证书" label-align="right" align="left" width="170px" span="2">{{item.zyzgzs}}</el-descriptions-item>
      <el-descriptions-item label="专业技术职务" label-align="right" align="left" width="170px" span="2">{{item.zyjszw}}</el-descriptions-item>
      <el-descriptions-item label="专业资格证书编号" label-align="right" align="left" width="170px" span="2">{{item.zyzgzsbh}}</el-descriptions-item>
      <el-descriptions-item label="专业技术职称获得日期" label-align="right" align="left" width="170px" span="2">{{item.zyjszcqdrq}}</el-descriptions-item>
      <el-descriptions-item label="专业证书名称" label-align="right" align="left" width="170px" span="2">{{item.zyzsmc}}</el-descriptions-item>
      <el-descriptions-item label="专业证书编号" label-align="right" align="left" width="170px" span="2">{{item.zyzsbh}}</el-descriptions-item>
      <el-descriptions-item label="专业证书取得日期" label-align="right" align="left" width="170px" span="2">{{item.zyzsqdrq}}</el-descriptions-item>
      <el-descriptions-item label="主要研究方向" label-align="right" align="left" width="170px" span="4">{{item.zyyjfx}}</el-descriptions-item>
      <el-descriptions-item label="" label-align="right" align="left" span="4"></el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script setup>
import { ref, defineProps, watch } from 'vue'
import { actionPost } from '@/api/common.js'

const props = defineProps({
  row: { type: Object, required: false }
})
const tableData = ref()

watch(
  () => props.row,
  () => {
    if (props.row) {
      const o = {
        url: '/api/v2/renliziyuan/jiaozhigongshuangshixingjiaoshipinyong/list',
        data: { id: props.row.id, order: 'gh', sort: 'asc' }
      }
      actionPost(o).then((res) => {
        tableData.value = res.data
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
